export default __webpack_public_path__ + "static/media/saasImg.5d6864ff.png";